<ng-container *ngIf="control && control.invalid && (control.dirty || control.touched)">
  <div class="error-message">
    <ng-container *ngIf="control.hasError('required')"> {{ 'shared.form.fillMsg' | translate }} </ng-container>
    <ng-container *ngIf="control.hasError('maxlength')">
      {{ 'shared.form.maxLengthMsg' | translate : { maxLength: control.errors?.['maxlength']?.requiredLength } }}
    </ng-container>
  </div>
</ng-container>
